import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconResetComponent } from "./med-icon-reset.component";

@NgModule({
  declarations: [
    MedIconResetComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconResetComponent,
  ],
})
export class MedIconResetModule { }
